import React from "react";
import axios from "axios";

import {withRouter} from 'react-router-dom';
import queryString from 'qs'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Footer from "components/Footer/Footer.jsx";
import PreLoginHeader from "components/Header/PreLoginHeader.jsx";

import { CircularProgress } from '@material-ui/core';
import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

import {getApiHeaders} from "../../assets/helpers/apiHelper";
import { API_ROOT, CREDIT_CARD_PROCESSOR } from 'api-config';
import { getSearchString } from "../../assets/helpers/urlHelper";

class CreditCardProcessorSignupFinalize extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      statusText: '',
      showProgressSpinner: true,
      showReturnToSettingsButton: false
    };

  }

  goToSettings(){
    let path = `settings`;
    this.props.history.push(path);
  }

  componentDidMount() {
    const searchString = getSearchString(this.props.location.search)
    const values = queryString.parse(searchString)
    const state = values.state
    const code = values.code
    const userId = sessionStorage.getItem('userId')
    if (code && state && userId) {
      this.setState({
        statusText: "Almost there. We're just finalizing your credit card processor set up.",
        showProgressSpinner: true
      })
      this.finalizeSignup(code, state, userId)
    } else {
      this.setState({
        statusText: 'There was an error linking your account. Please try again.',
        showProgressSpinner: false
      })
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }


  finalizeSignup(code, csrfToken, userId) {
    const connectedAccountdData = {
      userId: userId,
      csrfToken: csrfToken,
      code: code,
      type: CREDIT_CARD_PROCESSOR
    }
    axios.post(`${API_ROOT}/connectedAccount/`, connectedAccountdData, { headers: getApiHeaders() })
      .then(res => this.finalizeSignupResponse(res.data));
  }

  finalizeSignupResponse(res) {
    if (res.status === 'success') {
      this.setState({
        statusText: "We've set up your credit card processing. Please wait while we return you to your account",
        showProgressSpinner: false
      })
      setTimeout(() => {  this.goToSettings(); }, 3000);
    } else {
      var statusText
      if (res.error) {
        statusText = "There was an error: " + res.error + "."
      } else {
        statusText = 'There was an unknown error.'
      }
      statusText += ' Please return to the accounts settings page and try again.'

      this.setState({
        statusText: statusText,
        showProgressSpinner: false,
        showReturnToSettingsButton: true
      })
    }

  }


  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <PreLoginHeader />
        <GridContainer justifyContent="center">
          <GridItem xs={12} sm={6} md={4}>
            <form onSubmit={this.handleSubmit}>
              <Card>

                <CardBody>
                  <GridItem xs={12} sm={12}>
                    <CircularProgress size={20} style={this.state.showProgressSpinner ? {} : { display: 'none' }}/>
                    {this.state.statusText}
                  </GridItem>
                  <GridItem xs={12} sm={12}>
                    <Button
                      onClick={this.goToSettings.bind(this)}
                      color="cirrusBlue"
                      style={this.state.showReturnToSettingsButton ? {} : { display: 'none' }}
                    >
                      return to account settings
                    </Button>
                  </GridItem>
                </CardBody>

              </Card>
            </form>
          </GridItem>

        </GridContainer>
        <Footer fluid />
      </div>
    );
  }
}


export default withRouter(withStyles(loginPageStyle)(CreditCardProcessorSignupFinalize));
